const productCards = document.querySelectorAll('[product-card]');
const activeProductCards = [];

productCards.forEach(productCard => {
  const hoverVideo = productCard.querySelector('[product-hover-video]');

  if (!hoverVideo) {
    return;
  }

  const productCardLink = productCard.querySelector('[product-card-link]');

  productCardLink.addEventListener('click', (event) => {
    const mobileBreakpoint = '(max-width: 777px)';
    const isMobileDevices = window.matchMedia(mobileBreakpoint).matches;
    const isActive = productCard.classList.contains('is-active');

    if (!isMobileDevices || isActive) {
      return;
    }

    productCard.classList.add('is-active');

    activeProductCards.push(productCard);

    event.preventDefault();
  });
});

document.addEventListener('click', (event) => {
  if (activeProductCards.length === 0 || event.target.closest('[product-card]')) {
    return;
  }

  activeProductCards.forEach(activeProductCard => activeProductCard.classList.remove('is-active'));

  activeProductCards.length = 0;
});

const rebuyCartEvents = ['rebuy:cart.add', 'rebuy:cart.change'];

rebuyCartEvents.forEach(eventName => {
  document.addEventListener(eventName, (event) => {
    const { cart } = event.detail;

    const itemCount = cart.cart.item_count;

    document.querySelectorAll('[data-count]').forEach(counter => {
      counter.setAttribute('data-count', itemCount);
      counter.querySelector('[data-ajax-cart-bind="item_count"]').textContent = itemCount;
    });
  });
});